import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHikeNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.086 1.86C5.45 1.322 6.058 1 6.707 1h.626c.284 0 .532.191.605.465l.568 2.15a4.708 4.708 0 003.206 3.308l2.413.719A2.625 2.625 0 0116 10.157v.253c0 .217-.026.477-.134.738a4.426 4.426 0 01-1.311 1.73C13.775 13.504 12.632 14 11 14H9.333a.625.625 0 01-.16-.02l-2.307-.614-.41.437A.625.625 0 016 14H2.625A2.625 2.625 0 010 11.375v-.24c0-.445.151-.877.43-1.224l.423-.53.415-4.599A1.958 1.958 0 013.218 3h1.095zm1.621.39a.708.708 0 00-.586.311L4.976 4.25H3.218a.708.708 0 00-.705.645L2.143 9c1.471.011 2.22.204 2.827.406l.211.072c.457.156.79.271 1.486.271h5c.294 0 .456-.073.573-.157.14-.1.254-.241.43-.472l.016-.022c.103-.135.23-.303.393-.465l-1.724-.514a5.96 5.96 0 01-.452-.154L9.441 9.433l-.886-.882 1.186-1.19a5.96 5.96 0 01-.692-.542L7.937 7.935l-.886-.882 1.165-1.17c-.174-.242-.33-.498-.467-.767L6.433 6.437l-.885-.882 1.721-1.728-.417-1.577zm-5.302 8.442a.708.708 0 00-.155.442v.241c0 .76.616 1.375 1.375 1.375H5.73l.737-.783 2.948.783H11c1.36 0 2.223-.406 2.772-.846.558-.45.828-.967.94-1.235a.684.684 0 00.038-.26v-.252c0-.333-.12-.645-.325-.887a.788.788 0 00-.332.137c-.14.1-.253.241-.43.472l-.016.022c-.157.206-.372.49-.68.709-.34.244-.761.39-1.3.39h-5c-.909 0-1.414-.174-1.896-.34l-.196-.067c-.499-.166-1.142-.343-2.575-.343h-.241z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHikeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHikeNormalXsmall;
